import React, { useState } from 'react';
import PageContainer from '../../components/container/PageContainer';
import { Typography, Box, CircularProgress, Tabs, Tab } from '@mui/material';
import MinistryWiseReport from '../../components/ministryWiseReport';
import EventCreationReports from '../../components/eventCreationReport';
import LocationWiseReport from '../../components/locationWiseReport';
import { useSelector } from 'react-redux';
import EventDetailedReport from '../../components/eventDetailedReport';
import {
  VISIBLE_REPORT_YEARS,
  DEFAULT_REPORT_YEAR,
  isApiReportYear,
} from '../../constants/reportYears';

const Reports = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(1);
  // Fall back to whatever is visible if the default year is currently hidden,
  // so the page cannot open on a year that has no tab (indexOf would be -1 and
  // the Tabs strip would render with nothing selected).
  const [selectedYear, setSelectedYear] = useState(
    VISIBLE_REPORT_YEARS.includes(DEFAULT_REPORT_YEAR)
      ? DEFAULT_REPORT_YEAR
      : VISIBLE_REPORT_YEARS[0]
  );
  const role = useSelector((state) => state.RoleReducer);

  // The year tabs used to be a hardcoded 2025/2024 pair keyed off the tab
  // index. They are driven off REPORT_YEARS now so that adding a campaign year
  // is a one-line change there rather than an edit to every index comparison.
  const handleYearChange = (event, newValue) => {
    setSelectedYear(VISIBLE_REPORT_YEARS[newValue]);
    setSelectedTab(1); // Reset to default tab when year changes
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  // Every report component takes the year and branches on it internally
  // (isApiReportYear), so one switch serves all years.
  //
  // key={selectedYear} remounts on a year switch rather than re-rendering.
  // Without it the component keeps the previous year's state -- most visibly
  // the selected event theme, which is not offered by every year (Clean Green
  // Utsav is 2025-only, the SHS-2026 pillars are 2026-only), so the dropdown
  // and the table it fetched could end up disagreeing.
  const renderTabContent = () => {
    switch (selectedTab) {
      case 0:
        return (
          <MinistryWiseReport key={selectedYear} setIsLoading={setIsLoading} year={selectedYear} />
        );
      case 1:
        return (
          <LocationWiseReport key={selectedYear} setIsLoading={setIsLoading} year={selectedYear} />
        );
      case 2:
        return (
          <EventCreationReports
            key={selectedYear}
            setIsLoading={setIsLoading}
            year={selectedYear}
          />
        );
      case 3:
        return (
          <EventDetailedReport key={selectedYear} setIsLoading={setIsLoading} year={selectedYear} />
        );
      default:
        return null;
    }
  };

  // useEffect(() => {
  //   if (role?.info?.role_id === 13) {
  //     setSelectedTab(0);
  //   }
  // }, [role]);

  // if (!role?.info?.role_id) {
  //   return <></>;
  // }

  return (
    <PageContainer title="Reports" description="Reports">
      <Typography variant="h1" sx={{ textAlign: 'center', mt: 3 }}>
        Event Reports
      </Typography>
      {/* Year Tabs. Narrowed by UI_LOCKED_YEAR -- see constants/reportYears.js.
          Both the value and the map read the same list, so the tab index and
          the year stay in step however many are shown. */}
      <Tabs
        value={VISIBLE_REPORT_YEARS.indexOf(selectedYear)}
        onChange={handleYearChange}
        centered
        sx={{ mb: 2 }}
      >
        {VISIBLE_REPORT_YEARS.map((year) => (
          <Tab key={year} label={String(year)} />
        ))}
      </Tabs>
      {/* Report Tabs */}
      <Tabs value={selectedTab} onChange={handleTabChange} centered>
        {<Tab label="Ministry Wise Report" value={0} />}
        <Tab label="Location Wise Report" value={1} />
        {/* Event Creation Report is built off the legacy 2024 query path only. */}
        {!isApiReportYear(selectedYear) && <Tab label="Event Creation Report" value={2} />}
        {/* <Tab label="Event Detailed Report" value={3} /> */}
      </Tabs>
      {isLoading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      )}
      <Box sx={{ mt: 3, display: isLoading ? 'none' : 'flex' }}>{renderTabContent()}</Box>
    </PageContainer>
  );
};

export default Reports;
